import React from "react";

import Popup from "./Popup";

const PopupCallResult = props => {
  const { trigger, setTrigger, children } = props;

  return (
    <Popup title="Resultado da ligação" trigger={trigger} setTrigger={setTrigger}>
      <div className="sm-body">
        {children}
      </div>
    </Popup>
  );
}

export default PopupCallResult;